module.exports = __webpack_public_path__ + "img/04.e07c2f3a.jpg";